// @flow

import React, { useState, useEffect, type Node } from 'react';
import styled from 'styled-components';

import { toDataURL as toQRCodeDataURL } from 'qrcode';
import { getNequiQRCodeValue } from '@tectonics/prs/incoming-payment/get-nequi-qrcode-info';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { base64toBlob } from '@tectonics/commons/base64-to-blob';
import { Link } from '../../../../atoms';

export function TicketCode(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const qrCodeValue = getNequiQRCodeValue(incomingPayment);
  const [qrCodeSrc, setQrCodeSrc] = useState();

  useEffect(() => {
    (async () => {
      const data = await toQRCodeDataURL(qrCodeValue);
      const base64 = data.substring(data.indexOf(',') + 1);
      const blob = base64toBlob(base64, 'image/png');
      setQrCodeSrc(URL.createObjectURL(blob));
    })();
  }, [qrCodeValue]);

  return (
    <Root>
      <Term>Paga con NEQUI</Term>
      <Caption>Abrí NEQUI en tu teléfono móvil y usa el siguiente código QR para pagar:</Caption>
      <div style={{ margin: '20px auto' }}>
        <img src={qrCodeSrc} alt={qrCodeValue} style={{ border: '2px solid rgba(0,0,0,.1)', height: '256px' }} />
      </div>
      <Link href={qrCodeSrc} download="qrcode.png"><strong>DESCARGAR CÓDIGO QR </strong></Link>
    </Root>
  );
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;

const Caption = styled.p`
  font-size: 0.9em;
  font-family: ${props => props.theme.fontFamily.sansSerif};
  margin: 0.5em 0;
`;
